




import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class RedirectView extends Mixins() {
  @Prop()
  redirect: string;

  created() {
    this.$router.replace(this.redirect);
  }
}
